import { AdSlotEvent, communicationService, universalAdPackage } from '@wikia/ad-engine';

export function activateFloorAdhesionOnICVAndUAPPages(callback: () => void) {
	// Trigger callback after top leaderboard has been resolved
	communicationService.onSlotEvent(
		AdSlotEvent.CUSTOM_EVENT,
		({ payload }) => {
			if (
				[
					universalAdPackage.SLOT_UNSTICKED_STATE,
					universalAdPackage.SLOT_FORCE_UNSTICK,
					universalAdPackage.SLOT_STICKY_STATE_SKIPPED,
					universalAdPackage.SLOT_VIDEO_DONE,
				].includes(payload.status)
			) {
				setTimeout(() => callback(), universalAdPackage.SLIDE_OUT_TIME);
			}
		},
		'top_leaderboard',
	);
}
